import { z } from 'zod'

export const RoundTripSchema = () => {
  return z.object({
    roundTrip: z.boolean(),
  })
}
